import { useMemo } from 'react';

import { useAuthContext } from '../../../../data/context/authContext';

/**
 * A hook to provide consistent text throughout the site for primary and secondary start assessment CTAs.
 * Also provides a loading text for the start assessment button.
 * Also provides a boolean to determine if the intro panel should be shown.
 */
const useStartConsultationCtaText = () => {
    const { isLoggedIn, authedBefore } = useAuthContext();

    // Works out the primary CTA text and if the intro panel is required.
    const primaryCta = useMemo(() => {
        let text = 'Start assessment';
        let introRequired = false;
        if (!isLoggedIn) {
            text = authedBefore ? 'Continue as Returning Patient' : 'Start assessment as New Patient';
            introRequired = !!authedBefore;
        }

        return { text, introRequired };
    }, [isLoggedIn, authedBefore]);

    // Works out the secondary CTA text and if the intro panel is required.
    const secondaryCta = useMemo(
        () => ({
            text: authedBefore ? 'Start Assessment as New Patient' : 'Log in as Returning Patient',
            // Disabled line as it's easier to read this way.
            introRequired: authedBefore ? false : true, // eslint-disable-line no-unneeded-ternary
        }),
        [authedBefore]
    );

    return {
        primaryCta,
        secondaryCta,
    };
};

export default useStartConsultationCtaText;
